import React from "react";

function IconReturn() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path d="M12.168 6v-.75V6zM3 6l-.45-.6a.75.75 0 000 1.2L3 6zm0 9.25a.75.75 0 000 1.5v-1.5zm9.168.75v-.75.75zM7.45 3.6a.75.75 0 10-.9-1.2l.9 1.2zm-.9 6a.75.75 0 10.9-1.2l-.9 1.2zm5.618-4.35H3v1.5h9.168v-1.5zM3 16.75h9.168v-1.5H3v1.5zm9.168 0c1.824 0 3.241-.716 4.193-1.824.938-1.092 1.389-2.523 1.389-3.926s-.45-2.834-1.389-3.926c-.952-1.108-2.37-1.824-4.193-1.824v1.5c1.398 0 2.396.534 3.055 1.301.672.783 1.027 1.852 1.027 2.949 0 1.097-.354 2.166-1.027 2.949-.659.767-1.657 1.301-3.055 1.301v1.5zM6.55 2.4l-4 3 .9 1.2 4-3-.9-1.2zm-4 4.2l4 3 .9-1.2-4-3-.9 1.2z" />
    </svg>
  );
}

export default IconReturn;
